function Card({ className, children }: { className?: string; children: React.ReactNode }) {
  return <div className={`${className} border border-borderGray rounded-md overflow-auto shadow-soft`}>{children}</div>
}
export default Card
